<template>
  <div id="sellerCartPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-cart-shopping fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">سبد سفارشات</span>
                </div>
              </div>
              <div class="col-3 text-center font-weight-bold">
                <span :class="registeredTab ? 'profile-active-tab':''" class="pointer font13px" @click="showRegisteredTab">ثبت شده</span>
              </div>
              <div class="col-3 text-center font-weight-bold">
                <span :class="confirmedTab ? 'profile-active-tab':''" class="pointer font13px" @click="showConfirmedTab">تایید شده</span>
              </div>
              <div class="col-3 text-center font-weight-bold">
                <span :class="deliveredTab ? 'profile-active-tab':''" class="pointer font13px" @click="showDeliveredTab">تحویل شده</span>
              </div>
              <div class="col-3 text-center font-weight-bold">
                <span :class="canceledTab ? 'profile-active-tab':''" class="pointer font13px" @click="showCanceledTab">لغو شده</span>
              </div>

            </div>
            <div class="row mx-1">
              <div  v-if="registeredTab" class="col-12">
                <SellerCartCard  :key="1" v-if="registerLoaded" :orders="registerOrders"/>
              </div>
              <div v-if="confirmedTab" class="col-12">
                <SellerCartCard  :key="2" v-if="confirmedLoaded" :orders="confirmedOrders"/>
              </div>
              <div v-if="deliveredTab" class="col-12">
                <SellerCartCard  :key="3" v-if="deliveredLoaded" :orders="deliveredOrders"/>
              </div>
              <div v-if="canceledTab" class="col-12">
                <SellerCartCard  :key="4" v-if="canceledLoaded" :orders="canceledOrders"/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </v-main>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
import SellerCartCard from "@/views/Seller/SellerCartCard";
export default {
  name: "SellerCart",
  metaInfo: {
    title: 'ایوان خانه- سبد سفارشات',
  },
  components: {SellerCartCard, BackBar},
  data: () => ({
    registeredTab: true,
    confirmedTab: false,
    deliveredTab: false,
    canceledTab: false,
    registerOrders:[],
    confirmedOrders:[],
    deliveredOrders:[],
    canceledOrders:[],
    registerLoaded:false,
    confirmedLoaded:false,
    deliveredLoaded:false,
    canceledLoaded:false,
  }),
  mounted() {
    this.getRegisteredOrders()
    this.getConfirmedOrders()
    this.getDeliveredOrders()
    this.getCanceledOrders()
  },
  methods: {
    showRegisteredTab() {
      this.registeredTab = true;
      this.confirmedTab = false;
      this.deliveredTab = false;
      this.canceledTab = false;
    },
    showConfirmedTab() {
      this.registeredTab = false;
      this.confirmedTab = true;
      this.deliveredTab = false;
      this.canceledTab = false;
    },
    showDeliveredTab() {
      this.registeredTab = false;
      this.confirmedTab = false;
      this.deliveredTab = true;
      this.canceledTab = false;
    },
    showCanceledTab() {
      this.registeredTab = false;
      this.confirmedTab = false;
      this.deliveredTab = false;
      this.canceledTab = true;
    },
    getRegisteredOrders(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_ListSetOrder", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.registerOrders= JSON.parse(result)
            this.registerLoaded=true
          })
          .catch(error => console.log('error', error));
    },
    getConfirmedOrders(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_ListApprove", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.confirmedOrders= JSON.parse(result)
            this.confirmedLoaded=true
          })
          .catch(error => console.log('error', error));
    },
    getDeliveredOrders(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_ListDeliver", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.deliveredOrders= JSON.parse(result)
            this.deliveredLoaded=true
          })
          .catch(error => console.log('error', error));
    },
    getCanceledOrders(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/InvoiceReportManagement/_ListCancel", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.canceledOrders= JSON.parse(result)
            this.canceledLoaded=true
          })
          .catch(error => console.log('error', error));
    },


  }
}
</script>

